export const GACategories = {
  network: "network"
};
